var map = {
	"./1/title-banner1-type2.png": "lrXQ",
	"./2/title-banner1-type2.png": "LZtX",
	"./3/title-banner1-type2.png": "m2LI",
	"./4/title-banner1-type2.png": "BGpP",
	"./5/title-banner1-type2.png": "KnFs",
	"./6/title-banner1-type2.png": "/Q7V",
	"./7/title-banner1-type2.png": "UCbZ",
	"./8/title-banner1-type2.png": "JH+R"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8rMH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/title\-banner1\-type2\.png$
// module id = 8rMH
// module chunks = 1